<template>
<v-container>
<v-card elevation="11" class=" pa-2" color="secondary" light>
 <v-card-title><h1 class="ma-4 d-flex justify-center textTitle--text font-weight-black">{{$t('views.beneficios.salebyprod')}}</h1></v-card-title> 
       
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        class="tertiary font-weight-black mx-8"
        hide-details
        outlined
      ></v-text-field>
    
    <v-data-table
    :headers="headers"
    :items="listVentaProds"
    class="elevation-5 tertiary pa-3 ma-5 textTable--text font-weight-black text-h3 text-center"
    :search="search"
    
  >
  <template v-slot:[`item.lastSaleDate`]="{ item }">
    
           <span>{{new Date(item.lastSaleDate) | dateFormat('DD MMMM YYYY')}}</span>
         </template>
    
    
    <template v-slot:[`item.actions`]="{ item }">
      
      <v-icon
        @click="detailsProduct(item)"
      >mdi-information-outline</v-icon>
      <v-dialog v-model="dialogDetails" max-width="80%" :retain-focus="false">
        
          
        </v-dialog>
    </template>
    
    
  </v-data-table>
      
    </v-card>
</v-container>
</template>

<script>
  export default {
      props:[],
    data () {
      return {
        search:'',
        
        listVentaProds:[],
        sales:[],
        dialogDetails:false,
        dialogDetailsKey:0
      }
    },
    computed:{
      headers(){
        var headers= [
              { text: this.$i18n.t('headers.actions'), value: 'actions', sortable: false,class: 'text-center quaterny primary--text font-weight-black text-subtitle-2' },
              {
                text: this.$i18n.t('headers.lastBuy'),
                align: 'start',
                value: 'lastSaleDate',
                class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'
              },
              {
                text: this.$i18n.t('headers.prodName'),
                align: 'start',
                value: 'name',
                class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'
              },
              { text: this.$i18n.t('headers.prodCode'), value: 'codigo',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              { text: this.$i18n.t('total'), value: 'totalSaleProd',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              { text: this.$i18n.t('unit'), value: 'unidadProdSold',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              { text: this.$i18n.t('headers.qtySold'), value: 'qtySaleProd',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              
              
            ]
          return headers
      }
    },
    mounted(){
        this.getListVentaProd()
    },
    methods: {
      detailsProduct(prod){
        console.log(prod)
      },
      getListVentaProd(){
        this.listVentaProds=[]
        this.sales=[]
        var nameprod=''
        var codigo=''
        var prodid=''
        var totalSaleProd=0
        var unidadProdSold=0
        var qtySaleProd=0
        var proditem={}
        var index
        var lastSaleDate

        const ventadb = this.$store.state.sales;
        if(ventadb){
            var keys = Object.keys(ventadb);
            keys.forEach(key => {
              if(key!=null){this.sales.push(ventadb[key])}
            
        });  
        }
        for(var i=0;i<this.sales.length;i++){
          for(var u=0;u<this.sales[i].products.length;u++){
            prodid=this.sales[i].products[u].id
              nameprod=this.sales[i].products[u].name
              codigo=this.sales[i].products[u].codigo
              totalSaleProd=this.sales[i].products[u].total
              qtySaleProd=1
              unidadProdSold=this.sales[i].products[u].qty
              lastSaleDate=this.sales[i].fecha
            proditem={id:prodid,name:nameprod,codigo:codigo,totalSaleProd:totalSaleProd,unidadProdSold:unidadProdSold,qtySaleProd:qtySaleProd,lastSaleDate:lastSaleDate}
            //console.log(this.listVentaProds.includes(item))
            if (this.listVentaProds.find(item => item.id === prodid)){
              index = this.listVentaProds.findIndex(item => item.id === prodid)
              this.listVentaProds[index].totalSaleProd+=this.sales[i].products[u].total
              this.listVentaProds[index].qtySaleProd+=1
              this.listVentaProds[index].unidadProdSold+=this.sales[i].products[u].qty
              this.listVentaProds[index].lastSaleDate=this.sales[i].fecha
              //console.log("exists",this.listVentaProds)
              }
            else {this.listVentaProds.push(proditem)
            //console.log(proditem)
            }

            
          }
        }
      },
        

    },
  }
</script>